import script from "./PortfolioDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioDropdown.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioDropdown.vue?vue&type=style&index=0&id=1d53242a&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d53242a"]])

export default __exports__